import useModal from '@/hooks/useModal'
import { ReactElement, useCallback, useEffect, useState, cloneElement } from 'react'
import MAlert from '@/utils/modal/MAlert'
import { VStack, Modal } from '@musinsa/mwms-ds'
import Input from '@/components/content/Input'
import Table from '@/components/content/Table'
import { useGetMenuCode } from '@/services/menuCode/useMenuCodeQueries'
import { MenuCodeItem } from '@/services/menuCode/menuCode.types'

interface Props {
  trigger: React.ReactNode
  onSelect: (params: MenuCodeItem) => void
}

const MenuCodeSelectModal = ({ trigger, onSelect }: Props) => {
  const { open, onOpenModal, onCloseModal } = useModal()
  const [selectedIdx, setSelectedIdx] = useState(-1)
  const [menu, setMenu] = useState('')

  const { data, refetch, reset } = useGetMenuCode(menu)

  const onSearch = useCallback(() => {
    setSelectedIdx(-1)
    refetch()
  }, [])

  const onSubmit = useCallback(() => {
    if (selectedIdx === -1) {
      return MAlert.show('메뉴코드를 선택해주세요')
    }

    onSelect(data[selectedIdx])
    onCloseModal()
  }, [selectedIdx])

  useEffect(() => {
    if (!open) {
      setMenu('')
      reset()
    }
  }, [open, reset])
  return (
    <>
      {trigger &&
        cloneElement(trigger as ReactElement, {
          onClick: onOpenModal,
        })}
      {open && (
        <Modal
          open
          size="md"
          title="메뉴코드 검색"
          closable={false}
          buttons={[
            { kind: 'secondary', content: '닫기', onClick: onCloseModal },
            { kind: 'primary_light', content: '선택 완료', disabled: selectedIdx === -1, onClick: onSubmit },
          ]}
          onClose={onCloseModal}
        >
          <VStack gap={18}>
            <Input autoFocus label="메뉴코드" value={menu} placeholder="메뉴코드를 입력해주세요" onChange={setMenu} onEnter={onSearch} />
            <Table
              block
              data={data}
              height={400}
              emptyText="메뉴코드를 검색해주세요"
              onClickRow={(_, idx) => setSelectedIdx(idx)}
              columns={[
                { width: 30, render: (_, __, idx) => <input type="radio" checked={idx === selectedIdx} onChange={() => setSelectedIdx(idx)} /> },
                { key: 'menuCode', title: '메뉴코드', width: 100 },
                { key: 'menuName', title: '메뉴명' },
              ]}
            />
          </VStack>
        </Modal>
      )}
    </>
  )
}

export default MenuCodeSelectModal
